// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from '../../../actions';

// Custom
import { ActionButton } from "../Buttons/ActionButton";
import { CancelButton } from "../Buttons/CancelButton";
import { ErrorMessage } from "../ErrorMessage";

// Styled Components
import styled from 'styled-components';
import { FormGroup } from '../StyledComponents/FormGroup';
import { HiddenLabel } from '../StyledComponents/HiddenLabel';
import { FormIcon } from '../FormIcon';

// Form
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { TextFieldAdapter } from '../TextFieldAdapter';

// Utilities
import { required, isEmail, composeValidators, isNum, passwordsMustMatch } from '../validation';

const ConfirmStep = props => {
    
    const { handleConfirmData, handleClose, stepperControls, errors, resetErrors, clientData, bookingData } = props;
    console.log('CLIENT DATA IN CONFIRM STEP', clientData);
    const { reverseStepper, advanceStepper} = stepperControls;
    console.log('BOOKING DATA:', bookingData);
    return (
        <div label="Confirm Details">
            <Form
                onSubmit={handleConfirmData}
                initialValues={{
                    // Prefill form first with what they've typed this session then if they've not typed anyhitng use their profile data
                    firstName: (props.formValues) ? props.formValues.firstName : ( (props.clientData) ? (props.clientData.firstName) : '' ),
                    lastName: (props.formValues) ? props.formValues.lastName : ( (props.clientData) ? (props.clientData.lastName) : '' ),
                    email: (props.formValues) ? props.formValues.email : ( (props.clientData) ? (props.clientData.email) : ((props.userData) ? props.userData.email : '' )),
                    phone: (props.formValues) ? ((props.formValues.phone) ? props.formValues.phone : '') : ( (props.clientData) ? (props.clientData.phone ? props.clientData.phone : '') : '' ),
                    notes: (props.formValues) ? props.formValues.notes : ''
                }}
                render={({ handleSubmit, reset, submitting, pristine, values, invalid, empty }) => {
                    return (
                    <form id="detailsForm" onSubmit={handleSubmit}>
                        <FormGroup>
                            <HiddenLabel> First Name </HiddenLabel>
                            <FormIcon name="user" size={16} color="#9e9e9e" />
                            <Field
                                name="firstName"
                                component={TextFieldAdapter}
                                type="text"
                                placeholder="First Name"
                                validate={required}
                            />
                        </FormGroup>
                        <FormGroup>
                            <HiddenLabel> Last Name </HiddenLabel>
                            <FormIcon name="user" size={16} color="#9e9e9e" />
                            <Field
                                name="lastName"
                                component={TextFieldAdapter}
                                type="text"
                                placeholder="Last Name"
                                validate={required}
                            />
                        </FormGroup>
                        <FormGroup>
                            <HiddenLabel> Email </HiddenLabel>
                            <FormIcon name="envelope" size={16} color="#9e9e9e" />
                            <Field
                                name="email"
                                component={TextFieldAdapter}
                                type="email"
                                placeholder="Email"
                                validate={required}
                            />
                        </FormGroup>
                        {/* <FormGroup>
                            <HiddenLabel> Phone </HiddenLabel>
                            <FormIcon name="mobile"></FormIcon>
                            <Field
                                name="phone"
                                component={TextFieldAdapter}
                                type="number"
                                placeholder="Mobile Phone (optional: for SMS reminders)"
                                // validate={isNum}
                            />
                        </FormGroup> */}
                        <FormGroup>
                            <HiddenLabel> Reason for Booking </HiddenLabel>
                            <FormIcon name="file-alt" top={-50} size={16} color="#9e9e9e" />
                            <Field 
                                name="notes"
                                component={TextFieldAdapter}
                                placeholder={`Briefly describe your reason for booking...`}
                                multiLine={true}
                                rows={3}
                                validate={required}
                            />
                        </FormGroup>
                            
                        { errors && <ErrorMessage errors={errors} />}
                        
                        <ActionButton 
                            options={{
                                label: 'Confirm',
                                form: 'detailsForm',
                                action: (event)=>{
                                    document.getElementById('top').scrollIntoView();
                                    handleSubmit(event);
                                },
                                disabled: invalid || empty
                            }} 
                            // userId={props.userId}
                            advanceStepper={advanceStepper}
                        />
                        
                        <CancelButton 
                            handleClose={handleClose}
                            reset={reset} 
                            resetErrors={resetErrors}
                            clearAuthErrors={props.clearAuthErrors}
                        /> 
                    </form>
                )}}
            />
        </div>
    );
}

const mapStateToProps = ({auth, client, form, booking }) => {
    return {
        userData: auth.authData,
        clientData: client.clientData,
        formValues: form.formValues,
        formSubmitError: form.error,
        booking: { 
            details: booking.details,
            provider: booking.provider,
            service: booking.service
        }
    };
};

export default connect(mapStateToProps, actions)(ConfirmStep);


// WEBPACK FOOTER //
// ./src/js/components/Form/Steps/ConfirmStep.jsx